//====================================================
//  Function: Headeraction
//====================================================
function componentHeaderAction() {
  $(".form-group input[required]").each(function () {
    var group = $(this).closest(".form-group");
    group.addClass("is-required");
  });

  if ($(".toggle-window.cart-count").length) {
    $(".toggle-window.cart-count").wrapAll('<div class="click-cart"></div>');

    $(".click-cart").click(function () {
      if ($(window).width() < 768) {
        window.location.href = "/kosik";
        return false;
      }
    });
  }
}
